/**
 * Display types for text components
 * @name TextDisplayType
 */
export var TextDisplayType;
(function (TextDisplayType) {
    TextDisplayType["BLOCK"] = "block";
    TextDisplayType["FLEX"] = "flex";
    TextDisplayType["INLINE_BLOCK"] = "inline-block";
    TextDisplayType["INLINE_FLEX"] = "inline-flex";
    TextDisplayType["NONE"] = "none";
})(TextDisplayType || (TextDisplayType = {}));
//# sourceMappingURL=display.js.map